<template>
  <div>
    <header
      class="text-right d-flex align-items-center justify-content-between px-3 border-bottom"
    >
      {{ tabFunc }}
      <div class="d-flex align-items-center justify-content-start mobilehead">
        <div class="iconMobile mr-2">
            <feather
              type="menu"
              @click="
                $parent.classMobileResponsive = !$parent.classMobileResponsive
              "
            ></feather>
          </div>
        <div class="cap_logo text-center">
          <router-link :to="'/dashboard'" class="green">
            <img
              src="../../../../static/fxView/images/fxview_logo.svg"
              alt="fxView"
            />
          </router-link>
        </div>
        <div
          class="welcomeDiv d-none d-md-block"
          v-if="$route.path == '/dashboard' || $route.path == '/index'"
        >
          <div class="d-flex align-items-center justify-content-start">
            <div class="img mr-3">
              <img
                src="../../../../static/fxView/images/plant.svg"
                alt="plant"
              />
            </div>
            <div class="text-left">
              <h4 class="mb-0 text-capitalize">
                {{ $t("hello") }}
                <span v-if="get_user.profile.firstname != ''"
                  >{{ get_user.profile.firstname }}
                  {{ get_user.profile.lastname }}</span
                >
                <span v-else>{{ get_user.email }}</span>
              </h4>
              <!--  <small class="d-block">{{$t('headerMsz1')}} </small>  -->
            </div>
          </div>
        </div>
      </div>

      <div
        class="underverificationpopup"
        v-show="
          $route.path != '/index' &&
          shouldShow &&
          parseInt(get_user.verified_status) != 1 &&
          showGenralMessage &&
          parseInt(get_user.profile.ipv_status) == 1
        "
        v-bind:style="[minimize ? { height: '36px' } : {}]"
      >
        <div
          class="head d-flex align-items-center justify-content-between"
          :class="new_notification ? 'blinkmsg' : ''"
        >
          <div class="header-text">{{ $t("reviewStatus") }}</div>
          <div class="d-flex align-items-center">
            <feather
              class="xclose"
              type="minus"
              @click="minimize = !minimize"
            ></feather>
            <feather
              class="expand"
              type="maximize"
              @click="redirectToStep5()"
            ></feather>
          </div>
        </div>
        <div class="centerscroll scrollbar">
          <div id="idensic1"></div>
        </div>
      </div>

      <div
        class="underverificationpopup"
        v-show="
          $route.path != '/index' &&
          shouldShow &&
          parseInt(get_user.verified_status) != 1 &&
          showSomethingErrorMessage &&
          parseInt(get_user.profile.ipv_status) == 1
        "
        v-bind:style="[minimize ? { height: '36px' } : {}]"
      >
        <div
          class="head d-flex align-items-center justify-content-between"
          :class="new_notification ? 'blinkmsg' : ''"
        >
          <div class="header-text">{{ $t("reviewStatus") }}</div>
          <div class="d-flex align-items-center">
            <feather
              class="xclose"
              type="minus"
              @click="minimize = !minimize"
            ></feather>
            <feather
              class="expand"
              type="maximize"
              @click="redirectToStep5()"
            ></feather>
          </div>
        </div>
        <div class="centerscroll scrollbar">
          <div class="confirmPayment">
            <h3 class="mt-3 text-center">{{ $t("revStatUpdated") }}</h3>
            <p class="mt-3 text-center">{{ $t("reviewStatusUpdated") }}</p>
            <p class="mt-3 text-center">
              <button class="prism_btn btn_sm" @click="redirectToStep5()">
                {{ $t("Clicktoseedetail") }}
              </button>
            </p>
          </div>

          <!-- <div id="idensic1"></div>   -->
        </div>
      </div>

      <!-- showSomethingErrorMessage -->

      <div class="d-flex align-items-center rowreverse">
        <div class="d-flex align-items-center flex-wrap">
          <!----------------notification section---------------------------------->
          <div class="customDropdownOuter p-3 border-left ml-2">
            <div class="notifyicon">
              <div class="notificationbox dropopen d-flex align-items-center">
                <feather type="bell"></feather>
                <sup
                  v-if="
                    get_user.unread_notification &&
                    get_user.unread_notification != 0
                  "
                  >{{ get_user.unread_notification }}</sup
                >
              </div>
            </div>
            <div class="customDropdown customDropdown_css">
              <div
                class="customDropdownHead p-3 d-flex align-items-center justify-content-between"
              >
                <div class="headTitle">
                  {{ $t("Notification") }}
                </div>
                <div
                  class="HeadRight"
                  v-if="
                    get_user.unread_notification &&
                    get_user.unread_notification != 0
                  "
                >
                  <router-link :to="'/notification'"
                    >{{ $t("seeAll") }}
                  </router-link>
                </div>
              </div>
              <div class="customDropdownBox scrollbar" v-if="userNotify != ''">
                <div
                  class="d-flex align-items-center dropdownList"
                  v-for="list in userNotify"
                >
                  <div class="usericon mr-3 text-center">
                    <feather type="mail" size="1rem"></feather>
                  </div>
                  <div @click="notifyFunc(list)" class="right text-left">
                    <p>{{ list.message }}</p>
                    <div class="d-block time">
                      {{ list.created_on | moment("DD MMMM YYYY") }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="noNotifications" v-else>
                <img
                  src="../../../../static/fxView/images/noticket.svg"
                  alt="No Notification"
                />
                {{ $t("noNewNotification") }}
              </div>
            </div>
          </div>
          <!------------------user info section-------------------------------->
          <div class="customDropdownOuter border-left py-2 pl-2">
            <div
              class="user-header dropopen1 d-flex align-items-center ml-2"
              v-if="get_user.profile.firstname != ''"
            >
              {{ get_user.profile.firstname.charAt(0)
              }}{{ get_user.profile.lastname.charAt(0) }}
            </div>
            <div
              class="user-header dropopen1 d-flex align-items-center ml-2"
              v-else
            >
              {{ get_user.email.charAt(0) }}
            </div>
            <div class="customDropdown dropdownSM userprofilesetting">
              <div
                class="customDropdownHead p-3 d-flex align-items-center text-left"
              >
                <div class="headTitle">
                  <div class="bold">
                    {{ get_user.profile.firstname }}
                    {{ get_user.profile.lastname }}
          
                  </div>
                  <span>{{ get_user.email }}</span>
                  <div class="user_verification">
                    <span
                      class="user_verified"
                      v-if="parseInt(get_user.verified_status) == 1"
                      >{{ $t("verified") }}
                    </span>
                    <span class="not_verified" v-else
                      >{{ $t("notVerified") }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="customDropdownBox">
                <ul class="user" role="menu" aria-labelledby="menu1">
                  <li role="presentation">
                    <router-link :to="'/profile'"
                      >{{ $t("profile") }}
                    </router-link>
                  </li>
                  <li role="presentation">
                    <router-link :to="'/download-platform'"
                      >{{ $t("downloadPlatform") }}
                    </router-link>
                  </li>
                  <li role="presentation">
                    <router-link :to="'/api-documentation'"
                      >Developer Console</router-link
                    ><!-- /rest-api -->
                  </li>
                  <li role="presentation">
                    <router-link :to="'/change-password'"
                      >{{ $t("changePassword") }}
                    </router-link>
                  </li>
                  <li role="presentation">
                    <router-link :to="'/two-fa'"
                      >{{ $t("security") }}
                    </router-link>
                  </li>
                  <!--<li role="presentation"><router-link :to="'/subscription-tool'">{{$t('Subscription')}}</router-link></li>-->
                  <div class="border-top"></div>
                  <li>
                    <a role="menuitem" tabindex="-1" href="#" @click="logout()"
                      >{{ $t("logout") }}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <!------------demo live buttons section----------------------->
        <div class="getStartButton d-flex align-items-center flex-wrap">
          <a
            href="#"
            class="btn_xs grd_btn mr-2 newtrading"
            @click="showTabFunc('platform')"
          >
            <img
              src="../../../../static/fxView/images/icolive.svg"
              alt="Live Account"
              class="mr-2"
              width="25"
            />
            <span v-if="tradingAccountList.totalRecords > 0">
              <label v-if="showText == '1'">{{
                $t("addNewTradAccount")
              }}</label>
              <label v-else>{{ $t("startTrading") }}</label>
            </span>
            <span v-else>{{ $t("startTrading") }} </span>
          </a>
          <router-link
            :to="'/index'"
            class="btn_xs grd_btn grd_red mr-md-2 newtrading"
            v-if="handleCurrentStep() && newUpdate"
            :class="$route.path == '/index' ? 'disabled' : ''"
            @click="changeStatus()"
            >{{ $t("revStatUpdated") }}</router-link
          >

          <router-link
            :to="'/index'"
            class="btn_xs grd_btn grd_red mr-2"
            v-if="handleCurrentStep() && !newUpdate"
            :class="$route.path == '/index' ? 'disabled' : ''"
            >{{ $t("verification") }} ({{
              Math.floor(getCurrentSteps() * 16.67)
            }}%)</router-link
          >
          <!--v-if="parseInt(get_user.step) > 4 && get_user.pro_user==0&& get_user.pro_user==0 && get_user.profile.total_points > 0"-->
          <router-link
            :to="'/pro'"
            class="btn_xs grd_btn mr-2"
            v-if="
              parseInt(get_user.verified_status) == 1 &&
              parseInt(get_user.pro_user) == 0
            "
          >
            {{ $t("becomeAPro") }}
          </router-link>
        </div>
      </div>
    </header>
    <app-trading-accounts
      v-if="showTab == 'trading_account'"
      class="trading1"
    ></app-trading-accounts>
    <app-platform-type
      v-if="showTab == 'platform'"
      class="trading2"
    ></app-platform-type>
  </div>
</template>
<script>
import * as types from "@/types";
import { mapActions } from "vuex";
import { fxViewMixins } from "@/plugins/fxView";
import tradingAccounts from "../tradingAccounts/trading_accounts";
import platformType from "../tradingAccounts/platform_type";
import i18n from "@/plugins/lang/i18n";
import * as firebase from "firebase/app";
import "firebase/messaging";

import EventBus from "@/plugins/fxView/provider/candle-history/lib/event-bus";

export default {
  name: "Header",
  mixins: [fxViewMixins],
  data() {
    return {
      showText: "1",
      showTab: "",
      langtext: "English",
      flagico: "flag-eng",
      live: "1",
      newUpdate: false,
      shouldShow: false,
      minimize: false,
      new_notification: false,
      showSomethingErrorMessage: false,
      platformIcon: {
        MT4: "platforn-icon-1.svg",
        MT5: "platforn-icon-3.svg",
        ACT: "platforn-icon-2.svg",
      },
      liveDemoIcon: { 0: "Demo", 1: "Live", 0: "Demo", 1: "live" },
      showGenralMessage: false,
    };
  },
  props: ["show_tab"],
  components: {
    appTradingAccounts: tradingAccounts,
    appPlatformType: platformType,
  },
  computed: {
    tabFunc() {
      //this.showTab = this.show_tab
      //console.log(this.showTab)
    },
  },
  methods: {
    showTabFunc(getData) {
      if (this.showTab == getData) {
        this.showTab = "";
        this.$parent.show_tab = "";
      } else {
        this.showTab = getData;
        this.$parent.show_tab = getData;
      }
    },
    ...mapActions({
      _runUserLogout: types.RUN_USER_LOGOUT,
      _runSaveuserToken: types.SAVE_FIREBASE_TOKEN,
    }),
    getFirebaseToken() {
      //save user token on the web
    },
    redirectToStep5() {
      //alert("hello atleast called")
      this.$router.replace({ name: "fxView.welcome" });
    },
    changeStatus() {
      this.newUpdate = false;
    },
    handleCurrentStep() {
      let step = false;
      if (parseInt(this.get_user.step) != 5 && !this.get_user.edittedStepAfterLogin) {
        step = true;
      } else if (parseInt(this.get_user.step) != 6 && this.get_user.edittedStepAfterLogin === true) {
        step = true;
      } else if (parseInt(this.get_user.step) != 6 && !this.get_user.edittedStepAfterLogin && this.get_user.edittedStepAfterLogin === false) {
        step = true;
      } else {
        step = false;
      }
      return step;
    },
    notifyFunc(getList) {
      if (getList.notification_type == "TICKET") {
        this.$router.replace({
          name: "fxView.view",
          query: { id: getList.ticket_id },
        });
      }
    },
    logout() {
      const _that = this;
      let input_json = {
        globalParams: {},
        localParams: {
          parameter: _that,
        },
      };
      _that._runUserLogout(input_json);
    },
    getCurrentSteps() {
      let currentStep = this.get_user.step;

      if ("tempStep" in this.get_user && currentStep < this.get_user.tempStep) {
        currentStep = this.get_user.tempStep;
      }

      this.userStep = currentStep;
      return currentStep;
    },
    changeLocale(locale, lang, flagicon) {
      this.langtext = lang;
      this.flagico = "flag " + flagicon;
      i18n.locale = locale;
    },
    demoLiveFunction(getData) {
      this.$emit("localStroageChange", getData);
      localStorage.setItem("demo_live", getData);
      this.$router.replace("/steps1");
    },
    showUpdatedData() {
      //alert("called")
    },
    saveFirebaseNotification(token) {
      // _runSaveuserToken
      const _that = this;
      let input_json = {
        globalParams: {
          firebaseToken: token,
        },
        localParams: {
          parameter: _that,
        },
      };
      _that._runSaveuserToken(input_json);
    },
    intializeFirebase() {
      const _that = this;
      const firebaseConfig = {
        apiKey: "AIzaSyCmsD-2IT6CCFUyj_fSGnaqhANqVk8naic",
        authDomain: "fxview-d860f.firebaseapp.com",
        databaseURL: "https://fxview-d860f.firebaseio.com",
        projectId: "fxview-d860f",
        storageBucket: "fxview-d860f.appspot.com",
        messagingSenderId: "462578346086",
        appId: "1:462578346086:web:8e33088eca7ff2cbfbe5a7",
      };
      firebase.initializeApp(firebaseConfig);
      try{
        navigator.serviceWorker
          .register("/static/firebase-messaging-sw.js")
          .then(function (registration) {
            const messaging = firebase.messaging();
            messaging.usePublicVapidKey(
              "BCJRn_O4j3bPnNuhkqyPy7uDwXkMiT6wOl4rYZV8xX9wxGZeVrLLjNUrc3YnPIWi2gW0plEqzdicmWnSsMTBg3o"
            );
            messaging.useServiceWorker(registration);
  
            messaging
              .getToken()
              .then((currentToken) => {
                if (currentToken) {
                  // console.log("Current Push notification token", currentToken)
                  //sendTokenToServer(currentToken);
                  //updateUIForPushEnabled(currentToken);
                  _that.saveFirebaseNotification(currentToken);
                } else {
                  // Show permission request.
                  // console.log('No Instance ID token available. Request permission to generate one.');
                  // Show permission UI.
                  // updateUIForPushPermissionRequired();
                  // setTokenSentToServer(false);
                }
              })
              .catch((err) => {
                // _that.reaskPermission()
                // console.log('An error occurred while retrieving token. ', err);
                // showToken('Error retrieving Instance ID token. ', err);
                // setTokenSentToServer(false);
              });
  
            messaging.onMessage((payload) => {
              _that.newUpdate = true;
              //
              // alert("Message received bhai")
              // ...
            });
  
            messaging.onTokenRefresh(function () {
              messaging
                .getToken()
                .then(function (newToken) {
                  _that.saveFirebaseNotification(newToken);
                  // this.saveNotificationToken(newToken)
                })
                .catch(function (err) {
                  console.log("Unable to retrieve refreshed token ", err);
                });
            });
          })
          .catch(function (err) {
            console.error("Service Worker registration failed", err);
          });
      }catch(e){}
    },
    intializeSumSubForHeaer(accessToken, ExtUserId, levelname) {
      const _that = this;
      _that.shouldShow = true;
      _that.showGenralMessage = true;

      // var id = idensic.init(
      //     // selector of the WebSDK container (see above)
      //     '#idensic1',
      //     // configuration object (see settings in the demo)
      //     {
      //         // provide your clientId (can be seen in the demo)
      //         clientId: 'fxview',
      //         // access token for specific externalUserId
      //         accessToken: accessToken,
      //         // may be some additional parameters, see the Demo to see which ones, e.g.
      //         externalUserId: ExtUserId,

      //         "uiConf": {
      //          "customCssStr": "button.submit:active:not(:disabled), button.submit:hover:not(:disabled):not(.disabled):not(:active), button[type=submit]:active:not(:disabled), button[type=submit]:hover:not(:disabled):not(.disabled):not(:active), #loader .round-icon, .round-icon{ background: #25c16f; color: #fff; background-image:none;}button.submit, button[type=submit]{ background: #25c16f; color: #fff;} .step.active .title, h3, h4, .content .desktop p, .document-status h2{color:#414649} .step.active .bullet:before, .step.active.success .bullet:before, .radio-item .checkmark:after{background-color:#25c16f} .mobile-button .fa-icon, .accent{color:#25c16f} .checkbox input:checked~.checkmark{background-color:#25c16f ;border-color:#25c16f} .step.active .line, .step.success .line{background-color:#25c16f} .document-status p, p, .checkbox, .radio-item{color:#888da8;}"

      //         },

      //         "navConf": {
      //          "showWelcomeScreen": false,
      //          "skipAgreementsScreen": true
      //         },

      //     },
      //     // function for the WebSDK callbacks
      //     function(messageType, payload) {

      //         // if(messageType == 'idCheck.onApplicantRequestAccepted'){
      //         //     // _that.skipDocumentUpload()
      //         // }

      //         // console.log(messageType, payload)

      //         // if(messageType == 'idCheck.onApplicantSubmitted'){
      //         //     //_that.skipDocumentUpload()
      //         //     _that.displayAvailableOption()
      //         // }
      //         // if(messageType == 'idCheck.onApplicantResubmitted'){
      //         //     //_that.skipDocumentUpload()
      //         //     _that.displayAvailableOption()
      //         // }

      //         if("reviewStatus" in payload && payload.reviewStatus == "completed" ){
      //             if("reviewResult" in payload && "reviewRejectType" in payload.reviewResult && payload.reviewResult.reviewRejectType == 'RETRY'){

      //                 _that.new_notification = true;

      //             }

      //             if("reviewResult" in payload && "reviewRejectType" in payload.reviewResult && payload.reviewResult.reviewRejectType == "FINAL"){
      //                 //show message that status has been updated.
      //                  _that.new_notification = true;
      //                  _that.showSomethingErrorMessage = true
      //                 _that.showGenralMessage = false
      //             }

      //             if("reviewResult" in payload && "reviewRejectType" in payload.reviewResult && payload.reviewResult.reviewAnswer == "GREEN"){

      //                 _that.new_notification = true;
      //                 _that.showSomethingErrorMessage = true
      //                 _that.showGenralMessage = false
      //                 //show message that status has been updated.
      //             }
      //         }else{
      //            if(messageType == 'idCheck.applicantStatus'){
      //                 _that.new_notification = true;
      //             }
      //         }

      //         setTimeout(function(){
      //             _that.new_notification = false;
      //         }, 10000)
      //     }
      // )

      // console.log(accessToken, ExtUserId)

      // this.accToken = accessToken
      // this.levelname = levelname
      // this.user_id = ExtUserId

      _that.launchWebSdk1(
        "https://api.sumsub.com",
        levelname,
        accessToken,
        this.get_user.email,
        "",
        ""
      );
    },

    launchWebSdk1(
      apiUrl,
      flowName,
      accessToken,
      applicantEmail,
      applicantPhone,
      customI18nMessages
    ) {
      const _that = this;
      let snsWebSdkInstance = snsWebSdk
        .init(accessToken, () => this.getNewAccessToken())
        .withBaseUrl("https://api.sumsub.com")
        .withConf({
          lang: "en", //language of WebSDK texts and comments (ISO 639-1 format)
          email: applicantEmail,
          phone: applicantPhone,
          i18n: customI18nMessages, //JSON of custom SDK Translations
          uiConf: {
            customCssStr:
              "button.submit:active:not(:disabled), button.submit:hover:not(:disabled):not(.disabled):not(:active), button[type=submit]:active:not(:disabled), button[type=submit]:hover:not(:disabled):not(.disabled):not(:active), #loader .round-icon, .round-icon{ background: #25c16f; color: #fff; background-image:none;}button.submit, button[type=submit]{ background: #25c16f; color: #fff;} .step.active .title, h3, h4, .content .desktop p, .document-status h2{color:#414649} .step.active .bullet:before, .step.active.success .bullet:before, .radio-item .checkmark:after{background-color:#25c16f} .mobile-button .fa-icon, .accent{color:#25c16f} .checkbox input:checked~.checkmark{background-color:#25c16f ;border-color:#25c16f} .step.active .line, .step.success .line{background-color:#25c16f} .document-status p, p, .checkbox, .radio-item{color:#888da8;}",
            // customCss: "https://url.com/styles.css"
            // URL to css file in case you need change it dynamically from the code
            // the similar setting at Customizations tab will rewrite customCss
            // you may also use to pass string with plain styles `customCssStr:`
          },
        })
        .withOptions({ addViewportTag: false, adaptIframeHeight: true })
        // see below what kind of messages WebSDK generates
        .on("idCheck.onApplicantSubmitted", (payload) => {
          // console.log('stepCompleted', payload)

          setTimeout(function () {
            _that.displayAvailableOption();
          }, 15000);
        })
        .on("idCheck.onApplicantResubmitted", (payload) => {
          setTimeout(function () {
            _that.displayAvailableOption();
          }, 15000);

          if (messageType == "idCheck.applicantStatus") {
            if (
              "reviewStatus" in payload &&
              payload.reviewStatus == "completed"
            ) {
              // _that.skipDocumentUpload()

              if (
                "reviewResult" in payload &&
                "reviewRejectType" in payload.reviewResult &&
                payload.reviewResult.reviewRejectType == "RETRY"
              ) {
                setTimeout(function () {
                  _that.iframeVar = true;
                  _that.showFeaturesDiv = false;
                  _that.asktoallowNotification = false;
                }, 15000);
              } else {
                _that.getSumSubResp();
              }
            } else if (
              "reviewStatus" in payload &&
              payload.reviewStatus == "pending"
            ) {
              // _that.skipDocumentUpload()
              setTimeout(function () {
                _that.displayAvailableOption();
              }, 15000);
            } else {
              // this.iframeVar = true
              // this.showFeaturesDiv = false
              // this.asktoallowNotification = false
            }
            // _that.skipDocumentUpload()
          }
        })
        .on("idCheck.applicantStatus", (payload) => {
          if (
            "reviewStatus" in payload &&
            payload.reviewStatus == "completed"
          ) {
            // _that.skipDocumentUpload()

            if (
              "reviewResult" in payload &&
              "reviewRejectType" in payload.reviewResult &&
              payload.reviewResult.reviewRejectType == "RETRY"
            ) {
              setTimeout(function () {
                _that.iframeVar = true;
                _that.showFeaturesDiv = false;
                _that.asktoallowNotification = false;
              }, 15000);
            } else {
              _that.getSumSubResp();
            }
          } else if (
            "reviewStatus" in payload &&
            payload.reviewStatus == "pending"
          ) {
            // _that.skipDocumentUpload()
            setTimeout(function () {
              _that.displayAvailableOption();
            }, 15000);
          } else {
            // this.iframeVar = true
            // this.showFeaturesDiv = false
            // this.asktoallowNotification = false
          }
          // _that.skipDocumentUpload()
        })
        .on("idCheck.onError", (error) => {
          console.log("onError", error);
        })
        .build();
      // you are ready to go:
      // just launch the WebSDK by providing the container element for it
      snsWebSdkInstance.launch("#idensic1");
    },
    updateFirstDeposit() {
      const _that = this;
      let input_json = {
        globalParams: {
          transaction_id : this.depositList.records[0].transaction_id,
        },
        localParams: {
          parameter: _that,
        },
      };
      _that._runUpdateFirstDeposit(input_json);
    },
    callDepositFunc(){
      if(parseInt(this.get_user.first_deposit) == 0 && this.checkSuccessDeposit()){
        window.gtag('event', 'FTD', {'event_name': 'FTD', 'send_to': 'G-1E20EEPN1W', 'user_id': "EU_"+this.get_user.profile.user_id});
        window.fbq('trackCustom', 'FTD', { 'value': '200', 'country':  this.get_user.profile.residence_country, 'Currency': 'USD'  }, { 'eventID': this.depositList.records.filter(val => parseInt(val.payment_status) == 1)[0].transaction_id });
        this.updateFirstDeposit()
      }
    },
     listing(){
      let inputJson = {
          'globalParams' : {
              filter: {},
              sort: [],
              search: '',
              page: 1,
              perPage: 15,
          } ,'localParams' : {'parameter' : this ,'from' : 'header'}
      }
      this._runGetDepositList(inputJson)
      },
      checkSuccessDeposit(){
      if(this.depositList.totalRecords){
        let data = this.depositList.records.filter(val => parseInt(val.payment_status) == 1)
        if(data.length > 0){
          return true
        }else{
          return false
        }
      }else{
        return false
      }
    },
  },
  created() {
    this.intializeFirebase();
    this.listing()

    if (
      parseInt(this.get_user.profile.ipv_status) &&
      this.$route.path != "/index" &&
      parseInt(this.get_user.verified_status) == 0
    ) {
      const _that = this;
      let input_json = {
        globalParams: {},
        localParams: { parameter: this },
      };
      this._runGetIdenfyToken(input_json);
    }
  },
  mounted() {
    const _that = this;
    $(".dropopen").click(function () {
      $(".customDropdown_css").toggleClass("show");
    });

    $(".dropopen1").click(function () {
      $(".userprofilesetting").toggleClass("show");
    });
    $(".tradingaccont").click(function () {
      $(".tradingaccontSM").toggleClass("show");
    });

    EventBus.$on("INTIALIZESUMSUB", function (payLoad) {
      const palod = payLoad;
      if (
        parseInt(_that.get_user.profile.ipv_status) &&
        parseInt(_that.get_user.verified_status) == 0 &&
        palod.accessToken != "" &&
        palod.user_id != "" &&
        _that.$router.currentRoute != "/index"
      ) {
        setTimeout(function () {
          _that.intializeSumSubForHeaer(
            palod.accessToken,
            palod.user_id,
            palod.levelname
          );
        }, 5000);
      }
    });

    $(document).on("click", function (event) {
      if (!$(event.target).closest(".dropopen").length) {
        $(".customDropdown_css").removeClass("show");
      }
      if (!$(event.target).closest(".dropopen1").length) {
        $(".userprofilesetting").removeClass("show");
      }
      if (!$(event.target).closest(".tradingaccont").length) {
        $(".tradingaccontSM").removeClass("show");
      }

      if (
        !$(event.target).closest(".hidetradingModal").length &&
        !$(event.target).closest(".trading1").length &&
        !$(event.target).closest(".trading2").length &&
        !$(event.target).closest(".newtrading").length
      ) {
        _that.showTab = "";
      }

      if (
        !$(event.target).closest(".iconMobile").length &&
        !$(event.target).closest(".iconMobileLeftbar").length
      ) {
        _that.$parent.classMobileResponsive = false;
      }
    });
    jQuery(document).ready(function ($) {
      var alterClass = function () {
        var ww = document.body.clientWidth;
        if (ww < 767) {
          _that.showText = "2";
        } else {
          _that.showText = "1";
        }
      };
      $(window).resize(function () {
        alterClass();
      });
      alterClass();
    });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/fxView/shared/header.vue